<template>
<div class="form-step-item">
    <div class="panel">
        <h3>Referring Healthcare Professional Details</h3>
        <div class="form-row">
            <div class="form-group col-8">
                <label for="referring_hospital">Referring Hospital *</label>
                <input type="text" class="form-control" v-model="formData.referring_hospital">
                <span class="form-error" v-if="$v.formData.referring_hospital.$dirty && !$v.formData.referring_hospital.required">Required field</span>
            </div>
        </div>
    </div>
    <div class="panel">
        <h4 v-if="formData.patient_type == 'nutrition'">Home PN Co-ordinator (key contact for all therapy and billing queries) *</h4>
        <h4 v-else>Home IVT Co-ordinator (key contact for all therapy and billing queries) *</h4>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="coordinator_first_name">First name *</label>
                <input type="text" class="form-control" v-model="formData.coordinator_first_name">
                <span class="form-error" v-if="$v.formData.coordinator_first_name.$dirty && !$v.formData.coordinator_first_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_last_name">Last name *</label>
                <input type="text" class="form-control" v-model="formData.coordinator_last_name">
                <span class="form-error" v-if="$v.formData.coordinator_last_name.$dirty && !$v.formData.coordinator_last_name.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="coordinator_job_title">Job title *</label>
                <input type="text" class="form-control" v-model="formData.coordinator_job_title">
                <span class="form-error" v-if="$v.formData.coordinator_job_title.$dirty && !$v.formData.coordinator_job_title.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_phone">Phone number *</label>
                <input type="text" class="form-control" v-model="formData.coordinator_phone">
                <span class="form-error" v-if="$v.formData.coordinator_phone.$dirty && !$v.formData.coordinator_phone.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_email">Email address *</label>
                <input type="text" class="form-control" v-model="formData.coordinator_email">
                <span class="form-error" v-if="$v.formData.coordinator_email.$dirty && !$v.formData.coordinator_email.required">Required field</span>
                <span class="form-error" v-if="$v.formData.coordinator_email.$dirty && !$v.formData.coordinator_email.email">Not a valid email</span>
            </div>
        </div>
    </div>
    <div class="panel" v-for="(v, index) in $v.formData.additionalHCPContacts.$each.$iter" v-bind:key="index">
        <h4>Additional HCP Contact {{parseInt(index) + 1}} <button type="button" class="btn-application-action btn-application-delete" @click.prevent="onDeleteHCP(index)"></button></h4>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="coordinator_first_name">First name *</label>
                <input type="text" class="form-control" v-model="formData.additionalHCPContacts[index].first_name">
                <span class="form-error" v-if="v.first_name.$dirty && !v.first_name.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_last_name">Last name *</label>
                <input type="text" class="form-control" v-model="formData.additionalHCPContacts[index].last_name">
                <span class="form-error" v-if="v.last_name.$dirty && !v.last_name.required">Required field</span>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col-4">
                <label for="coordinator_job_title">Job title *</label>
                <input type="text" class="form-control" v-model="formData.additionalHCPContacts[index].job_title">
                <span class="form-error" v-if="v.job_title.$dirty && !v.job_title.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_phone">Phone number *</label>
                <input type="text" class="form-control" v-model="formData.additionalHCPContacts[index].phone">
                <span class="form-error" v-if="v.phone.$dirty && !v.phone.required">Required field</span>
            </div>
            <div class="form-group col-4">
                <label for="coordinator_email">Email address *</label>
                <input type="text" class="form-control" v-model="formData.additionalHCPContacts[index].email">
                <span class="form-error" v-if="v.email.$dirty && !v.email.required">Required field</span>
                <span class="form-error" v-if="v.email.$dirty && !v.email.email">Not a valid email</span>
            </div>
        </div>
    </div>
  <div class="panel">
    <button class="lists-add" v-on:click="addHCPContact">Add another HCP contact</button>
  </div>

</div>
</template>


<script>

import { required, email } from 'vuelidate/lib/validators';

export default {
    name: 'FormStep3',
    components: {
    },
    props: {
        formData: {
            required: true,
        },
    },
    data() {
        return {
          additionalHCPContactTemplate:
            {
              first_name: '', last_name: '', job_title: '', phone: '', email: '',
            },
        };
    },
    validations: {
        formData: {
            referring_hospital: {
                required,
            },
            coordinator_first_name: {
                required,
            },
            coordinator_last_name: {
                required,
            },
            coordinator_job_title: {
                required,
            },
            coordinator_phone: {
                required,
            },
            coordinator_email: {
                required,
                email,
            },
            additionalHCPContacts: {
              $each: {
                first_name: {
                  required,
                },
                last_name: {
                  required,
                },
                job_title: {
                  required,
                },
                phone: {
                  required,
                },
                email: {
                  required,
                  email,
                },
              },
            },
        },
    },
    computed: {
    },
    methods: {
        validateForm() {
            this.$v.$touch();
            this.$emit('validation_response', !this.$v.$invalid);
        },
      addHCPContact() {
          this.formData.additionalHCPContacts.push(JSON.parse(JSON.stringify(this.additionalHCPContactTemplate)));
      },
      onDeleteHCP(index) {
        this.formData.additionalHCPContacts.splice(index, 1);
      },
    },
};
</script>
